import { PropsWithChildren, ReactElement } from "react";
import { ResultMapperColor } from "client/Api/IntegrationBuilder/integrationBuilderFlows";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import styles from "./ColoredText.module.less";

export type ColoredTextProps = {
	color: ResultMapperColor | nil;
	trackingId: string;
};

export const ColoredText = (props: PropsWithChildren<ColoredTextProps>): ReactElement => {
	const {
		trackingId,
		color,
		children
	} = props;

	return (
		<span
			{...setTrackingId(trackingId)}
			className={
				isNotNil(color)
					? mappedColorToStyleMap[color]
					: undefined
			}
		>
			{children}
		</span>
	);
};
ColoredText.displayName = "ColoredText";

const mappedColorToStyleMap: Record<ResultMapperColor, string> = {
	[ResultMapperColor.Green]: styles.root_success,
	[ResultMapperColor.Blue]: styles.root_info,
	[ResultMapperColor.Orange]: styles.root_warning,
	[ResultMapperColor.Red]: styles.root_danger,
	[ResultMapperColor.Grey]: styles.root_secondary,
	[ResultMapperColor.Default]: styles.root_primary,
	[ResultMapperColor.Purple]: styles.root_calendar6,
	[ResultMapperColor.Cyan]: styles.root_calendar9
};
